import type { DisplayEvent } from '../shared.js';
export function amsterdamDate(at = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit' }).format(at);
}
export function upcomingEvents(events: DisplayEvent[], at = new Date()): DisplayEvent[] {
  const today = amsterdamDate(at);
  return events.filter((event) => event.endDate >= today).sort((a, b) => a.startDate.localeCompare(b.startDate) || a.title.localeCompare(b.title));
}
/** Latest Monday 10:00 in local calendar time; restart-safe and DST-safe. */
export function eventSyncWeek(at = new Date()): string {
  const today = amsterdamDate(at);
  const date = new Date(`${today}T12:00:00Z`);
  const hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', hour: '2-digit', hourCycle: 'h23' }).format(at));
  let days = (date.getUTCDay() + 6) % 7;
  if (days === 0 && hour < 10) days = 7;
  date.setUTCDate(date.getUTCDate() - days);
  return date.toISOString().slice(0, 10);
}
